import React from 'react';

const ContactPage = () => {
  return (
    <div>
      <h1>Welcome to Quick But Healthy!</h1>
      <p>Contact Us here.</p>
    </div>
  );
};

export default ContactPage;
